import { CategorySelectorItemProps, ProductCategoryCount } from '@components';
import { Box, styled } from '@mui/material';
import classNames from 'classnames';

type CategorySelectorSubitemProps = Omit<CategorySelectorItemProps, 'isCategoryOpened'>;

const CategorySelectorSubitemWrapper = styled(Box)`
  display: flex;
  justify-content: left;
  margin-bottom: 10px;
  padding: 0 16px 0 30px;
  color: #616a6e;
  font-weight: 400;
  cursor: pointer;
  &.active {
    font-weight: 700;
  }
`;

const CategoryName = styled(Box)`
  cursor: pointer;
`;

export const CategorySelectorSubitem = ({
  category = {},
  skipEmptyCategories,
  onChange,
  isCategorySelected,
}: CategorySelectorSubitemProps) => {
  const isEmpty = !category?.productCount || category?.productCount === 0;
  if (skipEmptyCategories && isEmpty) {
    return null;
  }
  const mainClass = isCategorySelected && isCategorySelected(category) ? 'active' : '';
  return (
    <CategorySelectorSubitemWrapper
      onClick={() => onChange(category)}
      className={classNames(mainClass)}
    >
      <CategoryName>{category?.displayName}</CategoryName>
      <ProductCategoryCount className='subproduct-count'>
        ({category?.productCount})
      </ProductCategoryCount>
    </CategorySelectorSubitemWrapper>
  );
};
